import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="landing-calculator"
// Calculates potential revenue from converting missed calls to online bookings
export default class extends Controller {
  static targets = [
    "missedCalls",
    "missedCallsDisplay",
    "jobValue",
    "jobValueDisplay",
    "result",
    "jobsRecovered"
  ]

  // Conversion rate: 50% of missed calls would book if they could do it online
  static values = {
    conversionRate: { type: Number, default: 0.5 }
  }

  connect() {
    this.calculate()
  }

  calculate() {
    const missedCalls = parseInt(this.missedCallsTarget.value) || 5
    const jobValue = parseInt(this.jobValueTarget.value) || 350

    // Formula: missed_calls * conversion_rate * job_value
    const jobsRecovered = Math.round(missedCalls * this.conversionRateValue)
    const revenue = jobsRecovered * jobValue

    // Update displays
    this.missedCallsDisplayTarget.textContent = missedCalls
    this.jobValueDisplayTarget.textContent = jobValue.toLocaleString()
    this.resultTarget.textContent = revenue.toLocaleString()

    // Jobs recovered text (show range for realism)
    const lowEnd = Math.max(1, jobsRecovered - 1)
    const highEnd = jobsRecovered + 1
    this.jobsRecoveredTarget.textContent = jobsRecovered <= 1 ? "1" : `${lowEnd}-${highEnd}`
  }
}
